export const saveDesign = (payload) => {
    return {
        type: "SAVE_DESIGN",
        payload
    }
}
